import React, { useEffect, useState } from "react";

import { Dialog } from "@mui/material";
import axios from "axios";
import buildUrl from "build-url";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  disableLoaderAction, dispatchSelectCommand, enableLoaderAction
} from "../actions/globat-actions";
import DataTableToolbar from "../component/common/DatatableToolbar";
import FilterComponent from "../component/common/FilterComponent";
import SearchComponent from "../component/common/SearchComponent";
import PageHeader from "../component/common/PageHeader";
import EnhancerTatable from "../component/EnhancedTable";
import Configuration from "../environment";
import { deleteCommand } from "../services/CommandService";
import { showMessage } from "../services/MessageService";
import "./Command.css";

/**
 *
 *  the initialState const of the datatable
 */
const initalState = {
  totalElements: 0,
  page: 0,
  pageSize: 10,
  content: [],
};

const commandStatusLabel = (status) => {
  const value = (status || "").toUpperCase();
  if (["SUCCESS", "EXECUTED", "DONE", "COMPLETED"].includes(value)) {
    return "Terminée";
  }
  if (["FAILED", "ERROR", "CANCELLED"].includes(value)) {
    return "Échouée";
  }
  if (["PENDING", "SENT", "IN_PROGRESS"].includes(value)) {
    return "En cours";
  }
  return status;
};

const commandStatusVariant = (status) => {
  const value = (status || "").toUpperCase();
  if (["SUCCESS", "EXECUTED", "DONE", "COMPLETED"].includes(value)) {
    return "success";
  }
  if (["FAILED", "ERROR", "CANCELLED"].includes(value)) {
    return "failed";
  }
  return "pending";
};

const commandStatusPill = (status) => {
  const variant = commandStatusVariant(status);
  return (
    <span className={`command-status-pill command-status-pill-${variant}`}>
      <span className="status-dot"></span>{commandStatusLabel(status)}
    </span>
  );
};

/**
 *
 * The Headers cells definitions
 */
const commandHeadCells = [
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "ID",
    render: (row) => <span className="command-id-cell">#{row.id}</span>,
  },
  {
    id: "username",
    numeric: false,
    disablePadding: false,
    label: "Utilisateur",
  },
  {
    id: "commandAction",
    numeric: false,
    disablePadding: false,
    label: "Action",
    render: (row) => <span className="command-action-pill">{row.commandAction}</span>,
  },
  {
    id: "creationDate",
    numeric: false,
    disablePadding: false,
    label: "Créée le",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Statut",
    render: (row) => commandStatusPill(row.status),
  },
];

const blankCommand = {
  id: "",
  username: "",
  creationDate: "",
  executionDate: "",
  commandAction: "",
};

const mapDispatchToprops = (dispatch) => {
  return {
    enableLoading: () => dispatch(enableLoaderAction()),
    disableLoading: () => dispatch(disableLoaderAction()),
    selectCommand: (command) => dispatch(dispatchSelectCommand(command)),
  };
};

const fetchCommandByCriteria = async (criteria, page, pageSize) => {
  let noneBlankedCriteria = {};
  if (criteria.username !== "" && criteria.username !== undefined) {
    noneBlankedCriteria.username = criteria.username;
  }
  if (criteria.controllerName !== "" && criteria.controllerName !== undefined) {
    noneBlankedCriteria.controllerName = criteria.controllerName;
  }

  let uri = buildUrl(Configuration.backend_api_url, {
    path: "/commands",
    queryParams: {
      ...noneBlankedCriteria,
      page,
      pageSize,
    },
  });
  //+ encodeURIComponent(criteria);
  return await axios.get(uri, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
};

const CommandDetailPanel = (props) => {
  const command = props.command || {};
  const hasCommand = command.id !== undefined && command.id !== "";
  const [imageOpen, setImageOpen] = useState(false);

  if (!hasCommand) {
    return null;
  }

  return (
    <div className="command-detail-panel">
      <div className="command-detail-header">
        <span className="command-detail-title">Commande #{command.id}</span>
        <div className="command-detail-header-right">
          {commandStatusPill(command.status)}
          <span
            className="icon-button"
            role="button"
            tabIndex={0}
            aria-label="Fermer le détail"
            onClick={props.onClose}
            onKeyDown={(e) => e.key === "Enter" && props.onClose()}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </span>
        </div>
      </div>

      <div className="command-detail-fields">
        <div>
          <div className="command-detail-field-label">Contrôleur</div>
          <div className="command-detail-field-value">{command.controllerName}</div>
        </div>
        <div>
          <div className="command-detail-field-label">Demandée par</div>
          <div className="command-detail-field-value">{command.username}</div>
        </div>
        <div>
          <div className="command-detail-field-label">Exécutée le</div>
          <div className="command-detail-field-value">{command.executionDate || "—"}</div>
        </div>
        {command.apkVersion && (
          <div>
            <div className="command-detail-field-label">Version Apk</div>
            <div className="command-detail-field-value">{command.apkVersion}</div>
          </div>
        )}
      </div>

      <div className="command-detail-divider"></div>

      <div className="command-detail-field-label">Aperçu de la capture</div>
      {command.data ? (
        <div
          className="command-screenshot-frame"
          role="button"
          tabIndex={0}
          aria-label="Agrandir la capture d'écran"
          onClick={() => setImageOpen(true)}
          onKeyDown={(e) => e.key === "Enter" && setImageOpen(true)}
        >
          <img src={command.data} alt="Capture d'écran de la commande" />
        </div>
      ) : (
        <div className="command-screenshot-empty">
          <i className="fa fa-image" aria-hidden="true"></i>
          <span>Capture d'écran indisponible</span>
        </div>
      )}

      <Dialog open={imageOpen} onClose={() => setImageOpen(false)} maxWidth="lg">
        <img
          src={command.data}
          alt="Capture d'écran agrandie"
          style={{ display: "block", maxWidth: "90vw", maxHeight: "90vh" }}
        />
      </Dialog>
    </div>
  );
};

const CommandDataTable = connect(
  null,
  mapDispatchToprops
)((props) => {
  const [data, setData] = useState(initalState);

  const dispatch = useDispatch();
  const selectedCommand = useSelector((state) => state.selectCommandReducer);

  const selectRowCallback = (row) => {
    props.selectCommand(row);
  };

  const changePaginationActionHandler = (criteria, page, pageSize) => {
    props.enableLoading();

    fetchCommandByCriteria(criteria, page, pageSize).then(
      (response) => {
        setData(response.data);
        if (
          (selectedCommand === undefined || selectedCommand.id === "") &&
          response.data.content?.length > 0
        ) {
          props.selectCommand(response.data.content[0]);
        }
        props.disableLoading();
      },
      (err) => {
        showMessage(dispatch, err.message);
        props.disableLoading();
      }
    );
  };

  useEffect(() => {
    changePaginationActionHandler(
      props.searchCriteria,
      initalState.page,
      initalState.pageSize
    );
  }, [props.refresh, props.searchCriteria, props.refresh]);

  const deleteCommandAction = (id, callback) => {
    dispatch({ type: "START_LOADING" });
    deleteCommand(id)
      .then((resp) => {
        callback();
        dispatch({ type: "STOP_LOADING" });
        const deletedIds = String(id).split(",");
        if (deletedIds.includes(String(selectedCommand.id))) {
          props.selectCommand(blankCommand);
        }
        dispatch({ type: "REFRESH_DATATABLE" });
      })
      .catch((err) => {
        dispatch({ type: "STOP_LOADING" });
        showMessage(dispatch, err.message);
      });
  };

  return (
    <div className="command-table-col">
      <EnhancerTatable className="command-table"
        headCells={commandHeadCells}
        data={data}
        rowId="id"
        page={data.number}
        pageSize={data.pageable === undefined ? 0 : data.pageable.pageSize}
        searchCriteria={props.searchCriteria}
        displayEdit={false}
        entityName="Command"
        deleteAction={deleteCommandAction}
        changePaginationAction={changePaginationActionHandler}
        onClickCallBack={selectRowCallback}
        activeRowId={selectedCommand?.id}
      />
    </div>
  );
});

const Command = (props) => {
  const dispatch = useDispatch();

  const [searchCriteria, setSearchCriteria] = useState({
    commandAction: "",
    username: "",
    controllerName: "",
    creationDate: "",
  });

  const refresh = useSelector(
    (state) => state.DatatableReducer.refreshDatatable
  );
  const selectedCommand = useSelector((state) => state.selectCommandReducer);

  useEffect(() => {
    dispatch({ type: "UPDATE_SEARCH_MODEL", payload: searchCriteria });
  }, [dispatch, searchCriteria]);

  return (
    <div style={{ width: "90%", margin: "auto" }}>
      <PageHeader
        title="Commandes"
        subtitle="Historique des actions envoyées aux contrôleurs"
      />
      <div
        className={
          Object.keys(searchCriteria).find(
            (key) => searchCriteria[key] !== ""
          ) !== undefined
            ? "filter-section"
            : "filter-section hide"
        }
      >
        <span>Active Filters:</span>
        <div>
          <FilterComponent
            searchCriteria={searchCriteria}
            setSearchCriteriaCallback={setSearchCriteria}
          />
        </div>
      </div>

      <DataTableToolbar
        entityName="Command"
        displayAdd={false}
        displayUpload={false}
        displayExport={true}
        extraActions={
          <button
            type="button"
            className="command-refresh-btn"
            onClick={() => dispatch({ type: "REFRESH_DATATABLE" })}
            aria-label="Actualiser la liste des commandes"
          >
            <i className="fa fa-refresh" aria-hidden="true"></i>
            <span>Actualiser</span>
          </button>
        }
      >
        <SearchComponent
          searchModel={searchCriteria}
          searchAction={setSearchCriteria}
        />
      </DataTableToolbar>

      <div className="command-layout">
        <CommandDataTable refresh={refresh} searchCriteria={searchCriteria} />
        <CommandDetailPanel
          command={selectedCommand}
          onClose={() => dispatch(dispatchSelectCommand(blankCommand))}
        />
      </div>
    </div>
  );
};

export default Command;
